export interface IAccount {
  id: number;
  bankId: number;
  agency: string;
  number: string;
  digit: string;
  type: number;
}

export function mapBankAccounts(bankAccounts: any[]): IAccount[] {
  return (bankAccounts || []).map((bank) => ({
    id: bank.id || bank.accountId || bank.accountID,
    bankId: bank.bankID || bank.bankId,
    agency: bank.agency,
    number: bank.number || bank.accountNumber,
    digit: bank.digit || bank.accountDigit,
    type: bank.type || bank.accountType || 0,
  }));
}
